module.exports = __webpack_public_path__ + "static/media/AvenirNextLTPro-Bold.91d8ff8a.otf";